import { render, staticRenderFns } from "./appLogFieldRouteConfig.vue?vue&type=template&id=989e1d42&"
import script from "./appLogFieldRouteConfig.vue?vue&type=script&lang=js&"
export * from "./appLogFieldRouteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports